import React from "react";

type Props = {
    hasAthleticOutlook?: boolean;
    canCreateAthleticOutlook?: boolean;
    athleteName: string;
    onView: (event: React.MouseEvent) => void;
    onCreate: (event: React.MouseEvent) => void;
};

export default function AthleticOutlookActions({
    hasAthleticOutlook,
    canCreateAthleticOutlook,
    athleteName,
    onView,
    onCreate,
}: Props) {
    if (hasAthleticOutlook) {
        return (
            <button
                type="button"
                className="ath-preread-btn"
                onClick={onView}
                title={`View Pre-Read for ${athleteName}`}
                aria-label="Pre-Read"
            >
                <svg className="ath-preread-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden>
                    <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                    />
                    <polyline
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        points="14 2 14 8 20 8"
                    />
                    <path
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 15l2 2 4-4"
                    />
                </svg>
                Pre-Read
            </button>
        );
    }

    if (canCreateAthleticOutlook) {
        return (
            <button
                type="button"
                className="ath-add-preread-btn"
                onClick={onCreate}
                aria-label="Add Internal Coach Pre-Read"
            >
                + <span className="ath-preread-long">Internal Coach </span>Pre-Read
            </button>
        );
    }

    return null;
}
